module.exports = __webpack_public_path__ + "img/feed-2.12d72738.png";